<template>
  <div>
    <v-layout class="mb-5" align-start justify-left wrap>
      <v-flex>
        <v-card
          :color="navColor"
        >
          <v-card-text class="white--text">
            <div class="headline mb-2">{{totalAmount | price('INR')}}</div>
            <div v-if="filter.title || title">{{filter.title || title}}</div>
          </v-card-text>
          <v-data-table
            :loading="isDataLoading"
            :headers="headers"
            :items="reportItems"
            :items-per-page="15"
            @click:row="onRowClick"
            dense
            item-key="category.key"
          >
            <template v-slot:item.category="{ item }">
              <div>{{item.category.category.name}}</div>
            </template>
            <template v-slot:item.sum="{ item }">
              <div>{{item.sum | price('INR')}}</div>
            </template>
            <template v-slot:item.avg="{ item }">
              <div>{{item.avg | price('INR')}}</div>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { DataState } from "@/state";
import { Transaction, TransactionFilter } from "@/models/transaction";
export default {
  props: {
    title: String,
    filter: {
      type: Object
    },
    navColor: {
      type: String,
      default: "#385F73"
    },
  },
  data () {
    return {
      state: DataState.newLoading(),
      reportItems: [],
      totalAmount: 0,
      headers: [
        { text: "Category", value: "category" },
        { text: "Total", value: "sum"},
        { text: "Count", value: "count"},
        // { text: "Avg.", value: "avg"},
      ],
      // ignored: ['Between Accounts', 'Invalid Return', 'CapturedTax', 'Invalid Entry']
      ignored: ['Between Accounts', 'Invalid Return', 'Invalid Entry']
    }
  },
  computed: {
    isDataLoading () {
      return this.state && this.state.isLoading()
    }
  },
  mounted() {
    this.onLoaded();
  },

  methods: {
    onLoaded() {
      this.fetch()
    },
    fetch() {
      this.state.changeToLoading()
      let params = Object.assign({}, this.filter)
      Transaction.report(params).then(response => {
        this.parseItem(response.reportItems)
        this.state.changeToLoaded()
      })
      .catch(error => {
        this.state.changeToError(error)
      })
    },
    parseItem (items) {
      let newItems = []
      let total = 0

      items.forEach(item => {
        const name = item.category.category.name
        if (this.ignored.indexOf(name) == -1) {
          newItems.push(item)
          total += item.sum
        }
      })

      this.reportItems = newItems
      this.totalAmount = total
    },

    onRowClick (item) {
      this.$emit('rowClick', item, this.filter)
    }
  }
}
</script>

